
import $ from 'jquery';
import domready from '../utils/domready.js';
  domready(function() {
    $(document).on('click', '.accommodation-program__detail-trigger, .accommodation-program__title, .accommodation-program__close-trigger, .cta-sidebar__close', function() {
      var $this = $(this);
      var $container = $this.closest('.accommodation-program');
      if ($container.hasClass('is-active')) {
        $container.removeClass('is-active');
      } else {
        $container.addClass('is-active');
        $container.siblings('.accommodation-program').removeClass('is-active');

        var container = $container[0];
        var openedContainerTop = container.getBoundingClientRect().top;
        if (openedContainerTop < 48) { // 48 eqs 3rem of top-bar
          var scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
          window.scrollTo(0, scrollPosition + openedContainerTop - 48); // should be $container.scrollIntoView();, but well… iOS
        }
      }
    });
  });
